import { useEffect, useState } from 'react';

import { getDevice } from '@common/Util';
import { BACKEND_FILTER_VALUES } from '@config/filterOperators';
import { routes } from '@navigation/Constants';
import { getByPathAndParams } from '@services/BaseApi';

const useNews = (configuration, newsNumber) => {
  const [allNews, setAllNews] = useState([]);
  const [newsData, setNewsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [searchParams, setSearchParams] = useState({});

  const sortNews = (data = []) => {
    const today = new Date();

    const filteredNews = data.filter((news) => {
      const validFrom = news.validFrom ? new Date(news.validFrom) : null;
      const validTo = news.validTo ? new Date(news.validTo) : null;

      const isValidToday = validFrom && validTo ? validFrom <= today && today <= validTo : false;

      return isValidToday;
    });

    return filteredNews.sort((a, b) => {
      if (a.important === b.important) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      }
      return a.important ? -1 : 1;
    });
  };

  const getNewsData = async (path) => {
    try {
      const { data } = await getByPathAndParams({
        path,
        params: {
          filters: {
            advancedFilters: [
              {
                key: 'type',
                value: 'NEWS',
                operation: BACKEND_FILTER_VALUES.equals
              }
            ]
          }
        },
        temApi: true
      });

      if (data) {
        const sorted = sortNews(data?.content || []);

        setAllNews(sorted);

        const device = getDevice(window.innerWidth).toLowerCase() || 'computer';
        const size = newsNumber || configuration?.PAGINATION?.news?.[device] || 10;

        setTotalPages(Math.ceil(sorted.length / size));

        setNewsData(sorted.slice(0, size));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!allNews.length) return;

    const device = getDevice(window.innerWidth).toLowerCase() || 'computer';
    const size = newsNumber || configuration?.PAGINATION?.news?.[device] || 10;

    const start = (currentPage - 1) * size;
    const end = start + size;

    setNewsData(allNews.slice(start, end));
  }, [currentPage, allNews]);

  useEffect(() => {
    getNewsData(routes.path.consents);
  }, []);

  return {
    newsData,
    totalPages,
    currentPage,
    setCurrentPage,
    setSearchParams,
    isLoading
  };
};

export default useNews;
